import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { ToasterService, ToastType } from '../../../ts/services/ToasterService';

/**
 * Contains information to render a toast with a list of actions.
 * @property message - The message to display in the toast
 * @property action - An action to call when the corresponding link is clicked
 * @property actionMessage - The action link text
 */
export interface IActionableMessageProps {
  message: string;
  children?: React.ReactNode;
  actionMessage: string;
  action: () => void;
  testId: string;
}

// default action style
const defaultLinkProps = {
  href: 'javascript:;',
  style: {
    padding: '0px',
    marginLeft: TabStyles.Spacing.MediumSpace,
    color: 'inherit',
    fontWeight: 'bold',
    cursor: 'pointer',
    flexShrink: 0
  },
};

/**
 * Show an actionable toast using the specified actionable toast props
 * @param props - the props to render the actionable message. Contains the text and action props
 * @param toastType - The type of toast to show. Default is {@link ToastType.Info}
 */
export function showActionableToast(props: IActionableMessageProps, toastType: ToastType = ToastType.Info) {
  // get the toast service and show a toast with the actionable message as its content. Override
  // the actions to close the toast when they're clicked
  const service = ToasterService.instance;
  const toastId = service.pop({
    action: () => {
      props.action();
      service.close(toastId);
    },
    actionMessage: props.actionMessage,
    children: props.children,
    testId: props.testId,
    text: props.message,
    type: toastType,
  });
}
